<template>
  <div>
    <v-card
      :disabled="this.chargeIsTriggered"
      :color="this.$vuetify.theme.isDark ? 'black dark' : 'grey' + ' lighten-4'"
      flat
      class="px-3 my-3"
      style="
        border: 2px solid var(--v-primary-base) !important;
        border-radius: 15px !important;
      "
    >
      <v-card-title v-if="isZeroDiscount === false" class="title-exclusive"
        >Oferta exclusiva para esta compra</v-card-title
      >
      <v-card-title class="course-recommended">
        <span>
          {{ this.courseRecommendation.recommended_course.course }}
        </span>
        <span>
          <v-badge inline color="primary" v-if="isZeroDiscount === false">
            <template v-slot:badge>
              <span>{{
                `economize R$ ${courseRecommendation.discounted_price.replace(".", ",")}`
              }}</span>
            </template>
          </v-badge>
        </span>
      </v-card-title>
      <v-card-text style="padding: 0">
        <span>
          {{ courseRecommendation.recommended_course.description }}
        </span>
      </v-card-text>
      <v-card-text style="padding-bottom: unset; padding-left: 0; padding-top: 5px;">
        <div class="prices-container">
          <div class="discounted-price">
            R$ {{ formatPrice(discounted_amount) }}
          </div>
          <div class="previous-price" v-if="isZeroDiscount === false">
            R$ {{ formatPrice(courseRecommendation.recommended_course.price) }}
          </div>
        </div>
      </v-card-text>
      <v-checkbox
        hide-details
        class="mb-3"
        :label="labelText"
        style="padding-top: unset; padding-bottom: unset"
        v-model="check"
        :disabled="disableCheck"
        @change="
          (v) => {
            v ? this.addToCart() : this.resetCart();
          }
        "
      />
    </v-card>
  </div>
</template>

<script>
import OrdersService from "../../../services/orders.service";

export default {
  props: {
    order: {
      required: true,
    },
    courseRecommendation: {
      required: true,
    },
    chargeIsTriggered: {
      type: Boolean,
      default: false,
    },
    disableCheck: {
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
      showFooter: true,
      check: this.order.items.data.length >= 2,
      labelText: "QUERO APROVEITAR",
    };
  },
  methods: {
    formatPrice(price) {
      if (typeof price === "string") {
        price = parseFloat(price.replace(",", "."));
      }
      return price
        .toFixed(2) // Ensure two decimal places
        .replace(".", ",") // Replace decimal separator
        .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Add thousands separator
    },
    setAnalyticsAddToCartBump(order) {
      try {
        const course = order.items.data[1].saleable;
        const orderItem = order.items.data[1];
        const discount = parseFloat(orderItem.discount_amount);
        const coursePrice = parseFloat(course.price);
        const value = coursePrice - discount;

        this.$gtag.query("event", "add_to_cart", {
          value: value,
          currency: "BRL",
          items: [
            {
              id: order.id,
              name: course.course,
              sku: course.id,
              category: "Videoaula",
              discount: discount,
              price: parseFloat(course.price),
              quantity: "1",
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsAddToCartBump:", error);
      }
    },
    setAnalyticsRemoveFromCart(order) {
      try {
        const course = order.items.data[1].saleable;
        const orderItem = order.items.data[1];
        const discount = parseFloat(orderItem.discount_amount);
        const coursePrice = parseFloat(course.price);
        const value = coursePrice - discount;

        this.$gtag.query("event", "remove_from_cart", {
          value: value,
          currency: "BRL",
          items: [
            {
              id: order.id,
              name: course.course,
              sku: course.id,
              category: "Videoaula",
              discount: discount,
              price: parseFloat(course.price),
              quantity: "1",
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsRemoveFromCart:", error);
      }
    },
    async addToCart() {
      await OrdersService.addToCart(this.order.id, this.courseRecommendation.id)
        .then((resp) => {
          this.$emit("updateCart", resp.data);
          window.getApp.sendSnackMessage(
            `Curso adicionado com sucesso! 💰`,
            "success",
          );
          this.labelText = "ITEM ADICIONADO";
        })
        .catch((err) => {
          window.getApp.sendSnackMessage(err.message, "error");
        });
      this.setAnalyticsAddToCartBump(this.order);
    },
    async resetCart() {
      this.setAnalyticsRemoveFromCart(this.order);
      await OrdersService.resetCart(
        this.order.id,
        this.courseRecommendation.recommended_course_id,
      )
        .then((resp) => {
          this.$emit("updateCart", resp.data);
          window.getApp.sendSnackMessage(
            `Curso removido com sucesso! 💰`,
            "success",
          );
          this.labelText = "QUERO APROVEITAR";
        })
        .catch((err) => {
          window.getApp.sendSnackMessage(err.message, "error");
        });
    },
  },
  computed: {
    discounted_amount() {
      const discountAmount = (
        this.courseRecommendation.recommended_course.price -
        this.courseRecommendation.discounted_price
      ).toFixed(2);
      return discountAmount.replace(".", ",");
    },
    isZeroDiscount() {
      return parseInt(this.courseRecommendation.discounted_price) === 0;
    },
  },
};
</script>

<style scoped>
.prices-container {
  display: flex;
}

.previous-price,
.discounted-price {
  font-size: 16px;
  margin-right: 6px;
}

.previous-price {
  color: #888;
  text-decoration: line-through;
}

.title-exclusive {
  font-size: 1.2rem;
  word-break: break-word;
  padding: 7px 0 0 0;
}

.course-recommended {
  font-size: 1rem;
  display: block;
  align-items: baseline;
  word-break: break-word;
  padding: 3px 0 0 0;
}

@media (max-width: 386px) {
  .title-exclusive {
    font-size: 1.1rem;
  }

  .course-recommended {
    font-size: 0.9rem;
  }
}

@media (max-width: 348px) {
  .title-exclusive {
    font-size: 1rem;
  }

  .course-recommended {
    font-size: 0.8rem;
  }
}
</style>
